import { Link } from "react-router-dom";
import './App.css'

function App() {

  return (
    <div className="App">
      <h1>Checkers Game</h1>
      <p className="subtitle">Choose your game mode</p>
      <div className="game-modes">
        <Link to="/ai" className="game-mode-card">
          <div className="mode-icon">♟</div>
          <h2>Play against AI</h2>
          <p>Challenge our checkers engine</p>
        </Link>
        {/* <Link to="/multi" className="game-mode-card">
          <div className="mode-icon">♚♟</div>
          <h2>Multiplayer</h2>
          <p>Play with friends online</p>
        </Link> */}
      </div>
    </div>
  );
}

export default App;